import { getLocalState } from '../../Utils/localStorage';

const URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const getHeaders = () => {
  const token = getLocalState('token'); // Utiliser 'token' uniquement
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

const get = async (endpoint, signal = null) => {
  try {
    const fetchOptions = {
      method: 'GET',
      headers: getHeaders()
    };

    if (signal) {
      fetchOptions.signal = signal;
    }

    const response = await fetch(`${URL}/${endpoint}`, fetchOptions);

    // NE PAS faire window.location.href - laisser l'app gérer les erreurs
    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.response = { status: response.status };
      throw error;
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

const post = async (endpoint, payload = {}, signal = null) => {
  try {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: getHeaders()
    };

    if (signal) {
      fetchOptions.signal = signal;
    }

    const response = await fetch(`${URL}/${endpoint}`, fetchOptions);

    // NE PAS faire window.location.href - laisser l'app gérer les erreurs
    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.response = { status: response.status };
      throw error;
    }

    const data = await response.json();
    return { data, status: response.status };
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};

const put = async (endpoint, payload = {}, signal = null) => {
  try {
    const fetchOptions = {
      method: 'PUT',
      body: JSON.stringify(payload),
      headers: getHeaders()
    };

    if (signal) {
      fetchOptions.signal = signal;
    }

    const response = await fetch(`${URL}/${endpoint}`, fetchOptions);

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.response = { status: response.status };
      throw error;
    }

    const data = await response.json();
    return { data, status: response.status };
  } catch (error) {
    console.error('Error updating data:', error);
    throw error;
  }
};

const patch = async (endpoint, payload = {}, signal = null) => {
  try {
    const fetchOptions = {
      method: 'PATCH',
      body: JSON.stringify(payload),
      headers: getHeaders()
    };

    if (signal) {
      fetchOptions.signal = signal;
    }

    const response = await fetch(`${URL}/${endpoint}`, fetchOptions);

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.response = { status: response.status };
      throw error;
    }

    const data = await response.json();
    return { data, status: response.status };
  } catch (error) {
    console.error('Error patching data:', error);
    throw error;
  }
};

const deleteRequest = async (endpoint, signal = null) => {
  try {
    const fetchOptions = {
      method: 'DELETE',
      headers: getHeaders()
    };

    if (signal) {
      fetchOptions.signal = signal;
    }

    const response = await fetch(`${URL}/${endpoint}`, fetchOptions);

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.response = { status: response.status };
      throw error;
    }

    const data = await response.json();
    return { data, status: response.status };
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
};

export const Api = {
  get,
  post,
  put,
  patch,
  delete: deleteRequest
};